import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c8e50d68&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c8e50d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e50d68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8e50d68')) {
      api.createRecord('c8e50d68', component.options)
    } else {
      api.reload('c8e50d68', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c8e50d68&scoped=true&", function () {
      api.rerender('c8e50d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2We82f2iGvkGZ/JS/comp/GuestBox.vue"
export default component.exports